export const CASINO_IMGIX = "heathmont.imgix.net";
export const CDN_URL = "//cdn.coingaming.io";
export const CDN_IMG_URL = `${CDN_URL}/bitcasino/images`;
